<template>
  <li class="itemCharacter-li" @mouseover="showDesc()" @mouseleave="closeDesc()">
    <img class="itemCharacter-img" :src="img"/>
    <div class="itemCharacter-box">
      <p class="itemCharacter-name">{{personName}} &nbsp; {{position}}</p>
      <span>{{job}}</span>
    </div>
    <div class="itemCharacter-desc" ref="desc" style="display: none">
      <p class="itemCharacter-descName">{{personName}}</p>
      <p class="itemCharacter-descP">{{desc}}</p>
    </div>
  </li>
</template>
<script>
import '../../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'character',
  props: ['personName', 'position', 'job', 'img', 'desc'],
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
    // 个人简介
    showDesc () {
      this.$refs.desc.style.display = ''
    },
    closeDesc () {
      this.$refs.desc.style.display = 'none'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../joinprocess/main.css';
  .itemCharacter-li{
    float: left;
    margin: 10px;
  }
  .itemCharacter-img{
    width:189px;
    height:216px;
  }
  .itemCharacter-box{
    margin-top: -2px;
    width: 189px;
    height: 60px;
    padding: 0 8px;
    background-color: #d7dad5;
    text-align: center;
  }
  .itemCharacter-name{
    margin: 2px auto;
    color: #0052be;
    font-size: 14px;
    max-height: 21px;
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .itemCharacter-desc{
    width: 260px;
    padding: 15px;
    background-color: #ffffff;
    border: 2px solid #999999;
    position: absolute;
    transform: translate(189px,-276px);
  }
  .itemCharacter-descName{
    font-size: 18px;
    line-height: 20px;
    color: #0052be;
  }
  .itemCharacter-descP{
    line-height: 26px;
    text-indent:2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/item/itemCharacter.vue